/**
 * Find a Consultant directory.
 *
 * Two enhancements on archive-person.php, both optional:
 *
 *  1. The filter bar. It is the shared archive filter form, but the archive
 *     AJAX endpoint cannot render consultants, so here choosing an Expertise
 *     submits the form (a normal GET reload) and Enter in the search box does
 *     the same. Empty fields are left out of the URL. Without this script the
 *     form's own Apply button does the job.
 *
 *  2. "Full Bio". Each card renders a link to the profile page and a hidden
 *     button. Where <dialog> is supported the link is swapped for the button,
 *     which opens the card's bio pop-up with showModal(): the browser makes the
 *     page behind it inert, moves focus to the close button and closes it on
 *     Escape. Closing returns focus to the button that opened it; a click on
 *     the backdrop closes it too.
 */
(function () {
    'use strict';

    var directory = document.querySelector('[data-consultant-directory]');

    if (!directory) {
        return;
    }

    setupFilters(directory.querySelector('[data-archive-filters]'));
    setupModals(directory);

    /**
     * @param {HTMLFormElement|null} form The directory's filter form.
     */
    function setupFilters(form) {
        if (!form) {
            return;
        }

        var submit = form.querySelector('.archive-filters__submit');
        var search = form.querySelector('[data-archive-search]');

        if (submit) {
            submit.hidden = true;
        }

        function send() {
            // Leave empty controls out so the URL only carries real filters.
            Array.prototype.forEach.call(form.elements, function (field) {
                if (field.name && !field.value) {
                    field.disabled = true;
                }
            });

            form.submit();
        }

        // Coming back to the page from the history cache, the fields must not
        // still be disabled from the last submit.
        window.addEventListener('pageshow', function () {
            Array.prototype.forEach.call(form.elements, function (field) {
                field.disabled = false;
            });
        });

        form.addEventListener('submit', function (event) {
            event.preventDefault();
            send();
        });

        form.querySelectorAll('[data-archive-filter]').forEach(function (select) {
            select.addEventListener('change', send);
        });

        if (search) {
            search.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    send();
                }
            });
        }
    }

    /**
     * @param {HTMLElement} scope Element holding the cards and their dialogs.
     */
    function setupModals(scope) {
        var supported = typeof window.HTMLDialogElement === 'function'
            && typeof document.createElement('dialog').showModal === 'function';

        if (!supported) {
            return;
        }

        var opener = null;

        scope.querySelectorAll('[data-consultant-open]').forEach(function (button) {
            var dialog = document.getElementById(button.getAttribute('data-consultant-open'));
            var link = button.parentNode.querySelector('[data-consultant-link]');

            if (!dialog) {
                return;
            }

            button.hidden = false;

            if (link) {
                link.hidden = true;
            }

            button.addEventListener('click', function () {
                opener = button;
                dialog.showModal();
                document.documentElement.classList.add('has-consultant-modal');
            });
        });

        scope.querySelectorAll('[data-consultant-modal]').forEach(function (dialog) {
            var close = dialog.querySelector('[data-consultant-close]');

            if (close) {
                close.addEventListener('click', function () {
                    dialog.close();
                });
            }

            // The dialog box is the panel; a click that lands on the dialog
            // itself is a click on the backdrop around it.
            dialog.addEventListener('click', function (event) {
                if (event.target === dialog) {
                    dialog.close();
                }
            });

            dialog.addEventListener('close', function () {
                document.documentElement.classList.remove('has-consultant-modal');

                if (opener) {
                    opener.focus();
                    opener = null;
                }
            });
        });
    }
})();
